<template>
    <b-card header-tag="header" footer-tag="footer" class="mt-8">
        <template v-slot:header>
            <p class="mb-0" style="font-size: 21px">Items Del Pedido A Comprar</p>
        </template>
        <b-row align-h="between">
            <b-col cols="12" md="4">
                <b-button variant="danger" class="button-block-mobile" @click.prevent="dropCanastaItemsModal = true"><b-icon icon="trash"></b-icon> Vaciar Canasta</b-button>
            </b-col>
            <b-col class="text-right" cols="12" md="4">
                <b-button variant="info" class="button-block-mobile" v-if="canProcessOrder" @click.prevent="processPedido()">Procesar pedido</b-button>
            </b-col>
        </b-row>
        <b-card-text>
            <ItemsComponent 
                :items="items" 
                :opcionExistencia="opcionExistencia" 
                :enablePersonalizedDiscountSelect="enablePersonalizedDiscountSelect"
                :datoCalculos="datoCalculos"
                :comentario="comentario" 
                @get-cart-info-and-price="getCartInfoAndPrice()"
                @open-modal-order-comment="modalComment = true"
                />
        </b-card-text>
        <template v-slot:footer>
            <b-button variant="info" @click.prevent="printWindow">
                Imprimir
            </b-button>
        </template>
        
        <CommentOrderModal
            :modalComment="modalComment"
            @close-modal="modalComment = false"
            @add-comment-to-order="addCommentToOrder($event)"
            />
        <template v-if="modalSearchClient">
            <SearchClientModal
                :modalSearchClient="modalSearchClient"
                :datosCliente="datosCliente"
                :tipoDocumento="tipoDocumento"
                @close-modal="closeModalConsultClient()"
                @open-client-form-modal="clientFormModal($event)"
                />
        </template>
        <template v-if="clientDataModal">
            <ClientFormModal 
                :clientDataModal="clientDataModal"
                :clientData="clientData"
                :clientFormValidateError="clientFormValidateError"
                :tipoDocumento="tipoDocumento"
                :comentario="comentario"
                @close-modal="closeClientFormModal($event)"
                />
        </template>
        <ModalAlert 
            :openModal="errorNoStock" 
            title="No hay disponibbilidad de algunos articulos"
            message="Parece que algunos de los articulos no tiene disponibilidad, por favor verifique antes de procesar el pedido"
            @close-modal="errorNoStock = false"
            />
        
        <ModalConfirmDropCanasta 
            message="¿Esta seguro que desea eliminar todos los items de la canasta?"
            title="Vaciar Canasta"
            :openModal="dropCanastaItemsModal"
            @close-modal="dropCanastaItemsModal = false"
            @confirm-modal="dropCanastaItems"
            />
    </b-card>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import ItemsComponent from '../components/itemsComponent.vue'
import CommentOrderModal from '../components/CommentOrderModal.vue'
import SearchClientModal from '../components/SearchClientModal.vue'
import ClientFormModal from '../components/ClientFormModal.vue'
import ModalAlert from '@/components/ModalAlert.vue'
import ModalConfirmDropCanasta from '@/components/ModalConfirm.vue'
export default {
    data(){
        return{
            canProcessOrder: true,
            items: [],
            enablePersonalizedDiscountSelect: false,
            userPermissions: [],
            tipoDocumento: [],
            datoCalculos: {},
            comentario: null,
            addComment: "",
            modalComment: false,
            opcionExistencia: 0,
            noStockItem: false,
            modalSearchClient: false,
            clientData: {},
            datosCliente: {
                tipo_documento: ''
            },
            clientDataModal: false,
            errorNoStock: false,
            clientFormValidateError: [],
            dropCanastaItemsModal: false
        }
    },
    components: {
        ItemsComponent,
        CommentOrderModal,
        SearchClientModal,
        ClientFormModal,
        ModalAlert,
        ModalConfirmDropCanasta
    },
    created(){
        this.getCartInfoAndPrice();
    },
    methods: {
        ...mapActions('configuration', {
          _getCartCount: 'getCartItemsCountByUser',
        }), 
        ...mapMutations(['setLoading']),
        async getCartInfoAndPrice(){
            this.setLoading(true)
            this.userPermissions = localStorage.getItem('user_permissions');
            if(this.userPermissions.includes('can_use_personalized_discount')){
                this.enablePersonalizedDiscountSelect = true;
            }
            await this.$conectar.post('cart/get-cart-info-and-price')
            .then(response =>{
                if(response.data.error == false){
                    this.tipoDocumento = response.data.tipo_documento;
                    this.items = response.data.cartItems;
                    this.datoCalculos = response.data.cart;
                    this.opcionExistencia = response.data.opcionExistencia;
                    if(response.data.comentario !== null){
                        this.comentario = response.data.comentario;
                        this.addComment = this.comentario;
                    }
                }else{
                    this.items = [];
                    this.datoCalculos = {};
                    this.canProcessOrder = false;
                    this.$router.push({ name: 'dashboard' });
                }
                this._getCartCount();
                this.noStockItem = response.data.noStockItem;
            })
            .catch(e => {
                this.setLoading(false)
                console.log(e.response);
            })
            
            this.setLoading(false)
        },
        async addCommentToOrder(comment){
            this.setLoading(true)
            if(comment){
                this.comentario = comment;
                if (!comment.replace(/\s/g, '').length) {
                    this.comentario = null;
                }
                
            }else{
                this.comentario = null;
            }
            await this.$conectar.post('/cart/store-comment-cart', {comment: this.comentario})
                .then(response =>{
                    if(response.data.comentario !== null){
                        this.comentario = response.data.storeComment;
                        this.addComment = this.comentario;
                    }
                })
                .catch(e =>{
                    console.log(e.response);
                    this.setLoading(false)
            })
            this.modalComment = false;
            this.setLoading(false)
        },
        processPedido(){
            if(this.noStockItem === false){
                this.openModalConsultClient();
            }else{
                this.errorNoStock = true;
            }
        },
        closeModalConsultClient(){
            this.modalSearchClient = false;
            this.clientData = {};
            this.datosCliente = {
                tipo_documento: '',
                documento: ''
            }
        },
        openModalConsultClient(){
            this.modalSearchClient = true;
            this.clientData = {};
            this.datosCliente = {
                tipo_documento: '',
                documento: ''
            }
        },
        clientFormModal(clientData){
            this.clientData = clientData;
            this.clientDataModal = true;
        },
        closeClientFormModal(getCart){
            this.modalSearchClient = false;
            this.clientDataModal = false;
            this.clientData = {};
            if(getCart){
                this.getCartInfoAndPrice();
            }
        },
        async dropCanastaItems(){
            this.dropCanastaItemsModal = false;
            this.setLoading(true)
            await this.$conectar.post('cart/drop-canasta-items')
            .then(response => {
                if(response.data.error == false){
                    this.$root.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.$router.push({ name: 'dashboard' });
                }else{
                    this.$root.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }
                this._getCartCount();
                
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
            
        },
        printWindow() {
            window.print();
        },
    }
};

</script>
<style scoped>

@media all and (max-width:768px) {
   .button-block-mobile { 
        width: 100%; 
        display:block; 
    }
}  
</style>